import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-job-employee-title',
  templateUrl: './job-employee-title.component.html',
  styleUrls: ['./job-employee-title.component.scss'],
})
export class JobEmployeeTitleComponent implements OnInit {
  @Input() employeeTitle: any;
  color = '#';

  constructor() {}

  ngOnInit(): void {}

  getBackgroundColor() {
    return this.employeeTitle?.color ? this.employeeTitle?.color : '#F0F0F0';
  }
}
